import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(
    public afAuth: AngularFireAuth,
    public db: AngularFireDatabase
  ) {
  }


  // Reset Forgot password
  forgotPassword(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail)
  }


  
  updatePassword(newPassword) {
    this.afAuth.auth.currentUser.updatePassword(newPassword);
  }






  sendEmailVerification() {
    this.afAuth.auth.currentUser.sendEmailVerification();
  }

  deleteUser(uid: string) {
    return this.db.list('users').remove(uid);
  }

  loginUser(email: string, password: string) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
  }

  getUserbyEmail(email: string) {
    return this.db.list('users', ref => ref.orderByChild('email').equalTo(email)).snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload, ...c.payload.val() as {} })
        )
      )
    );
  }


  getUserByName(name: string) {
    return this.db.list('users', ref => ref.orderByChild('nom').equalTo(name)).snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload, ...c.payload.val() as {} })
        )
      )
    );
  }


  getUserByToken(name: string) {
    return this.db.list('users', ref => ref.orderByChild('token').equalTo(name)).snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.exists, ...c.payload.val() as {} })
        )
      )
    );
  }


  resetPassword(email: string) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }


  logoutUser(): Promise<void> {
    return this.afAuth.auth.signOut();
  }

  getUserUid() {
    if(!this.afAuth.auth.currentUser){
      return false;
    }else{
      return this.afAuth.auth.currentUser.uid;
    }
    
  }


  UpdateUser(UserKey, data) {
    if(UserKey && data){
      return this.db.list('users').update(UserKey, data);
    }
    
  }

  getUser(UserKey) {
    return this.db.object('users/' + UserKey).valueChanges();
  }

  addUser(idUser, data) {
    if(idUser && data){
      return this.db.list('users').update(idUser, data);
    }
  }


  signup(data: any) {
    return this.afAuth.auth.createUserWithEmailAndPassword(data.email, data.password).then(value => {
      data.token = value.user.uid;
      this.addUser(value.user.uid, data);
      return 'Client Ajouté avec succés';
    }).catch(err => {
      return err.message;
    });
  }


  getAllUser(idEhpad) {
    return this.db.list('users/', ref => ref.orderByChild('ehpad').equalTo(idEhpad)).snapshotChanges().pipe(
      map(changes =>
        changes.map(c => ({ key: c.payload.exists, ...c.payload.val() as {} })
        )
      )
    );
  }


}
